import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsCostGridUOM extends Component{ 

    constructor(props){
      super(props);

      this.state={
          costgriduoms:[],
          modalTitle:"",
          uomname:"",
          uomid:0,

          UomIdFilter:"",
          UomNameFilter:"",
          costgriduomsWithoutFilter:[],
          uomNames: [],
          uomExists: false, 
      }
  }

  FilterFn(){
    var UomIdFilter=this.state.UomIdFilter;
    var UomNameFilter = this.state.UomNameFilter;

    var filteredData=this.state.costgriduomsWithoutFilter.filter(
        function(el){
            return el.uomid.toString().toLowerCase().includes(
                UomIdFilter.toString().trim().toLowerCase()
            )&&
            el.uomname.toString().toLowerCase().includes(
                UomNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({costgriduoms:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.costgriduomsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({costgriduoms:sortedData});

}

changeUomIdFilter = (e)=>{
  this.state.UomIdFilter=e.target.value;
  this.FilterFn();
}
changeUomNameFilter = (e)=>{
  this.state.UomNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/costgriduoms/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({costgriduoms:data,costgriduomsWithoutFilter:data});
  });
}

fetchUomNames() {
  axiosService.get('/costgriduoms/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const uomNames = data.map(item => item.uomname);
      this.setState({ uomNames: uomNames });
    })
    .catch(error => {
      console.error("Error fetching uom names:", error);
    });
}

checkUomExists = (event) => {
  const enteredUom = event.target.value.toLowerCase(); // Convert to lowercase
  const { uomNames } = this.state;
  const uomExists = uomNames.some((uom) => uom.toLowerCase() === enteredUom);
  this.setState({ uomExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchUomNames();
}

changeUomName =(e)=>{
  this.setState({uomname:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add CostGridUOM",
      uomid:0,
      uomname: "",
      uomExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit CostGridUOM",
      uomid:dep.uomid,
      uomname:dep.uomname,
      initialUomname:dep.uomname,
      uomExists: false,
  });
}

createClick() {
  const { uomname, uomNames } = this.state;

  if (!uomname) {
    alert('UOM Name is required');
    return;
  }

  if (uomNames.some(name => name.toLowerCase() === uomname.toLowerCase())) {
    alert('Uom already exists. Please provide a unique Uom Name.');
    return;
  }

  axiosService.post('/costgriduoms/', {
    uomname: uomname
  })
    .then(result => {
      alert('CostGridUom created');
      this.refreshList();
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { uomname, initialUomname, uomNames } = this.state;

// Check if any changes are detected
if (
  uomname === initialUomname
) {
  alert('No changes detected');
  return;
}

if (
  uomNames.some(
    (existingUom) =>
      existingUom.toLowerCase() === uomname.toLowerCase()
  )
) {
  alert('Uom already exists. Please provide a unique Uom Name.');
  return;
}

if (!uomname) {
  alert('UOM Name is required');
  return;
}


  axiosService.patch('/costgriduoms/'+id+'/',{
      uomid:this.state.uomid,
      uomname:this.state.uomname
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/costgriduoms/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      costgriduoms,
      modalTitle,
      uomid,
      uomname,
      uomExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />




<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeUomIdFilter}
      placeholder="Filter"/>
      

      </div>
      CostGridUomId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeUomNameFilter}
      placeholder="Filter"/>

      </div>
      CostGridUom

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {costgriduoms.map(dep=>
      <tr key={dep.uomid} className="row-hover">
          <td className="table-text">{dep.uomid}</td>
          <td className="table-text">{dep.uomname}</td>
          <td className="table-text">

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Uom</span>
          <input
            type="text"
            className={`form-control ${uomExists ? "is-invalid" : ""}`}
            value={uomname}
            onChange={this.changeUomName}
            onBlur={this.checkUomExists} 
            style={{ fontSize: "12px" }} 
          />
          {uomExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Uom already exists.</div>}
        </div>

        {uomid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {uomid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(uomid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

  

